import { CDN_BASE } from "@/config"; 

export const cdnUrl = (path: string) => {
  // const base = getComputedStyle(document.documentElement)
  //   .getPropertyValue('--cdn-base')
  //   .trim();
  const base = CDN_BASE;
  // console.log("base", base);

  if(!base) {
    return path;
  }

  if(path.startsWith(base)) {
    return path;
  }

  return `${base}${path}`;
};